"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _commonLoader = require("@mmc/common-loader");
var _clsx = _interopRequireDefault(require("clsx"));
var _commonCta = require("@mmc/common-cta");
var _commonAccordion = require("@mmc/common-accordion");
var _commonDialog = require("@mmc/common-dialog");
var _reactApollo = require("react-apollo");
var _vinRecallLookup = _interopRequireDefault(require("./vin-recall-lookup.css"));
var _vinRecallItem = _interopRequireDefault(require("./vin-recall-item"));
var _query = require("./query");
var _uitl = require("./uitl");
var _CommonLoader;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var VinRecallSearch = function VinRecallSearch(_ref) {
  var _rawData$getVinRecall, _rawData$getVinRecall5;
  var theme = _ref.theme,
    data = _ref.data,
    inputId = _ref.inputId,
    whereCanFindId = _ref.whereCanFindId,
    language = _ref.language;
  var vinlookupurllabel = data.vinlookupurllabel,
    headline = data.headline,
    activevinDescription = data.activevinDescription,
    searchBarMaxCharacterLength = data.searchBarMaxCharacterLength,
    searchBarPlaceHolder = data.searchBarPlaceHolder,
    activevinTitle = data.activevinTitle,
    searchLabel = data.searchLabel,
    vinApiErrorMessage = data.vinApiErrorMessage,
    vinNotFoundMessage = data.vinNotFoundMessage,
    _data$vinlabel = data.vinlabel,
    recallNotice = _data$vinlabel.recallNotice,
    readMore = _data$vinlabel.readMore,
    modelName = _data$vinlabel.modelName,
    modelYear = _data$vinlabel.modelYear,
    priceLineName = _data$vinlabel.priceLineName,
    inServiceDate = _data$vinlabel.inServiceDate,
    recallNumber = _data$vinlabel.recallNumber,
    recallDate = _data$vinlabel.recallDate,
    lastUpdatedDate = _data$vinlabel.lastUpdatedDate,
    transportCanadaRecallNumber = _data$vinlabel.transportCanadaRecallNumber,
    recallType = _data$vinlabel.recallType,
    manufacturerRecallStatus = _data$vinlabel.manufacturerRecallStatus,
    recallDescription = _data$vinlabel.recallDescription,
    safetyRiskyDescription = _data$vinlabel.safetyRiskyDescription,
    remedyDescription = _data$vinlabel.remedyDescription,
    precautionsToMinimizeRisk = _data$vinlabel.precautionsToMinimizeRisk,
    recallStatus = _data$vinlabel.recallStatus,
    nhtsaRecallNumber = _data$vinlabel.nhtsaRecallNumber,
    repairDt = _data$vinlabel.repairDt,
    mileage = _data$vinlabel.mileage,
    recallClaimDescription = _data$vinlabel.recallClaimDescription,
    close = _data$vinlabel.close,
    recallCompletedLabel = _data$vinlabel.recallCompletedLabel,
    recallOpenLabel = _data$vinlabel.recallOpenLabel;
  var argsReadMoreInitial = {
    links: [{
      ctaType: 'button',
      label: close,
      priority: 'high'
    }],
    overlayCopy: {
      text: '',
      title: ''
    }
  };
  var _useState = (0, _react.useState)(''),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = (0, _react.useState)(true),
    isOverField = _useState2[0],
    setIsOverField = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    vinCountValid = _useState3[0],
    setVinCountValid = _useState3[1];
  var _useState4 = (0, _react.useState)(false),
    readMoreOpen = _useState4[0],
    setReadMoreOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(argsReadMoreInitial),
    argsReadMore = _useState5[0],
    setArgsReadMore = _useState5[1];
  var _useState6 = (0, _react.useState)(''),
    vinNumber = _useState6[0],
    setVinNumber = _useState6[1];
  var _useQuery = (0, _reactApollo.useQuery)(_query.GET_VIN_RECALL_LOOKUP_INFORMATION, {
      variables: {
        vin: value,
        market: 'ca',
        language: language
      },
      skip: !vinNumber,
      fetchPolicy: 'network-only'
    }),
    loading = _useQuery.loading,
    error = _useQuery.error,
    rawData = _useQuery.data;
  var errorMessage = '';
  if (error) {
    errorMessage = vinApiErrorMessage;
  }
  if (rawData && (rawData == null ? void 0 : (_rawData$getVinRecall = rawData.getVinRecallLookUpInformation) == null ? void 0 : _rawData$getVinRecall.status) !== '200') {
    errorMessage = vinNotFoundMessage;
  }
  var stringReplace = function stringReplace(str) {
    var _rawData$getVinRecall2, _rawData$getVinRecall3;
    var count = (rawData == null ? void 0 : (_rawData$getVinRecall2 = rawData.getVinRecallLookUpInformation) == null ? void 0 : _rawData$getVinRecall2.recallStatusInformationList) && (rawData == null ? void 0 : (_rawData$getVinRecall3 = rawData.getVinRecallLookUpInformation) == null ? void 0 : _rawData$getVinRecall3.recallStatusInformationList.length);
    return str.replace(/{vin_number}/g, value).replace(/{add_number}/g, count);
  };
  var handleSearch = function handleSearch(e) {
    e.preventDefault();
    setVinNumber(value);
  };
  var closeReadMoreOverlay = function closeReadMoreOverlay() {
    setReadMoreOpen(false);
  };
  var handleReadMoreEvent = function handleReadMoreEvent(text, title) {
    setReadMoreOpen(true);
    var argsReadMoreUpdate = _objectSpread({}, argsReadMoreInitial);
    argsReadMoreUpdate.overlayCopy = {
      title: title,
      text: text
    };
    setArgsReadMore(argsReadMoreUpdate);
  };
  var validateInputLength = function validateInputLength(input) {
    setVinCountValid(false);
    var count = input.length;
    if (count === Number(searchBarMaxCharacterLength)) {
      setVinCountValid(true);
    }
  };
  var handleInputChange = function handleInputChange(e) {
    setVinNumber('');
    var newValue = e.target.value;
    // Allow only letters and numbers
    var sanitizedValue = newValue.replace(/[^a-zA-Z0-9]/g, '');
    setValue(sanitizedValue);
    validateInputLength(sanitizedValue);
  };
  var handleInputBlur = function handleInputBlur() {
    setIsOverField(true);
  };
  var handleInputFocus = function handleInputFocus() {
    setIsOverField(false);
  };
  var renderVinInformation = function renderVinInformation(recallInfo) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: modelName,
      value: recallInfo.modelName,
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: priceLineName,
      value: recallInfo.priceLineName,
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: modelYear,
      value: recallInfo.modelYear,
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: inServiceDate,
      value: recallInfo.inServiceDate ? (0, _uitl.formatDate)(Number(recallInfo.inServiceDate), language) : '-',
      theme: theme
    }));
  };
  var renderRecallHeading = function renderRecallHeading(recallItem) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "" + theme.headingOne
    }, recallNotice, ": ", recallItem.recallNumber);
  };
  var renderRecallBody = function renderRecallBody(recallItem) {
    var _recallItem$recallNum, _recallItem$recallDes, _, _recallItem$mileage, _recallItem$recallCla, _recallItem$safetyRis, _recallItem$remedyDes, _recallItem$mfrRecall, _recallItem$recallTyp, _recallItem$precautio, _recallItem$transport;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: recallNumber,
      value: (_recallItem$recallNum = recallItem.recallNumber) != null ? _recallItem$recallNum : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: recallDescription,
      value: (_recallItem$recallDes = recallItem.recallDescription) != null ? _recallItem$recallDes : '-',
      theme: theme,
      readMore: readMore,
      handleReadMoreEvent: handleReadMoreEvent
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: recallStatus,
      value: recallItem.recallStatus && recallItem.recallStatus === 'Recall Open' ? recallOpenLabel : recallItem.recallStatus === 'Recall Completed' ? recallCompletedLabel : (_ = '-') != null ? _ : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: nhtsaRecallNumber,
      value: recallItem.nhtsaRecallNumber ? recallItem.nhtsaRecallNumber : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: repairDt,
      value: recallItem.repairDt ? (0, _uitl.formatDate)(Number(recallItem.repairDt), language) : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: mileage,
      value: (_recallItem$mileage = recallItem.mileage) != null ? _recallItem$mileage : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: recallDate,
      value: recallItem.recallDate ? (0, _uitl.formatDate)(Number(recallItem.recallDate), language) : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: recallClaimDescription,
      value: (_recallItem$recallCla = recallItem.recallClaimDescription) != null ? _recallItem$recallCla : '-',
      theme: theme,
      readMore: readMore,
      handleReadMoreEvent: handleReadMoreEvent
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: safetyRiskyDescription,
      value: (_recallItem$safetyRis = recallItem.safetyRiskDescription) != null ? _recallItem$safetyRis : '-',
      handleReadMoreEvent: handleReadMoreEvent,
      theme: theme,
      readMore: readMore
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: remedyDescription,
      value: (_recallItem$remedyDes = recallItem.remedyDescription) != null ? _recallItem$remedyDes : '-',
      theme: theme,
      readMore: readMore,
      handleReadMoreEvent: handleReadMoreEvent
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: manufacturerRecallStatus,
      value: (_recallItem$mfrRecall = recallItem.mfrRecallStatus) != null ? _recallItem$mfrRecall : '-',
      theme: theme,
      readMore: readMore,
      handleReadMoreEvent: handleReadMoreEvent
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: recallType,
      value: (_recallItem$recallTyp = recallItem.recallType) != null ? _recallItem$recallTyp : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: precautionsToMinimizeRisk,
      value: (_recallItem$precautio = recallItem.precautionsToMinimizeRisk) != null ? _recallItem$precautio : '-',
      theme: theme,
      readMore: readMore,
      handleReadMoreEvent: handleReadMoreEvent
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: transportCanadaRecallNumber,
      value: (_recallItem$transport = recallItem.transportCanadaRecallNumber) != null ? _recallItem$transport : '-',
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_vinRecallItem["default"], {
      label: lastUpdatedDate,
      value: recallItem.lastUpdatedDate ? (0, _uitl.formatDate)(Number(recallItem.lastUpdatedDate), language) : '-',
      theme: theme
    }));
  };
  var renderVinProcessedData = function renderVinProcessedData() {
    var _rawData$getVinRecall4;
    var recallCollection = rawData == null ? void 0 : (_rawData$getVinRecall4 = rawData.getVinRecallLookUpInformation) == null ? void 0 : _rawData$getVinRecall4.recallStatusInformationList;
    var accordionList = [];
    if (recallCollection && recallCollection.length) {
      recallCollection.forEach(function (recallItem) {
        accordionList.push(renderRecallHeading(recallItem));
        accordionList.push(renderRecallBody(recallItem));
      });
    }
    var getVinRecallLookUpInformation = rawData.getVinRecallLookUpInformation;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _vinRecallLookup["default"].recallResultsWrapper
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "" + theme.headingFour
    }, activevinTitle), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy + " " + theme.marginTop20 + " " + theme.marginBottom20
    }, stringReplace(activevinDescription)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _vinRecallLookup["default"].resultDataWrapper
    }, renderVinInformation(getVinRecallLookUpInformation), /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
      theme: theme,
      expanded: [0],
      headerClasses: [_vinRecallLookup["default"].accordionNoBorder, _vinRecallLookup["default"].accordionHeaderClasses],
      panelClasses: [_vinRecallLookup["default"].accordionNoBorder, _vinRecallLookup["default"].accordionPanelClasses]
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, accordionList)), /*#__PURE__*/_react["default"].createElement(_commonDialog.CommonDialog, {
      data: argsReadMore,
      theme: theme,
      isOpen: readMoreOpen,
      closeEvent: closeReadMoreOverlay,
      linkEvents: [closeReadMoreOverlay]
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vinRecallLookup["default"].vinSearchWrapper + " " + theme.marginTop50 + " " + theme.marginBottom50
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.introCopy + " " + theme.marginBottom30
  }, headline), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "" + inputId,
    className: _vinRecallLookup["default"].fieldLabel + " " + theme.labelSmall + " " + (isOverField && !value ? _vinRecallLookup["default"].isOverField : '')
  }, searchBarPlaceHolder && searchBarPlaceHolder.trim()), /*#__PURE__*/_react["default"].createElement("form", {
    className: "" + _vinRecallLookup["default"].formWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _vinRecallLookup["default"].formField
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    id: "" + inputId,
    className: (0, _clsx["default"])(_vinRecallLookup["default"].searchInput, errorMessage && _vinRecallLookup["default"].error),
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    maxLength: searchBarMaxCharacterLength,
    value: value
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: theme.mmcIconSearch + " " + _vinRecallLookup["default"].searchIcon
  })), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    disabled: !vinCountValid,
    clickEvent: handleSearch,
    data: {
      label: searchLabel,
      priority: 'high'
    },
    classes: ["" + _vinRecallLookup["default"].vinSearchBtn]
  })), errorMessage && /*#__PURE__*/_react["default"].createElement("p", {
    className: _vinRecallLookup["default"].errorMessage + " " + theme.BodyCopySm
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "error",
    className: _vinRecallLookup["default"].errorIcon,
    src: "data:image/svg+xml,%3Csvg width='11' height='10' viewBox='0 0 11 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 9.5h11L5.5 0 0 9.5zM6 8H5V7h1v1zm0-2H5V4h1v2z' fill='%23ED0000' fill-rule='nonzero'/%3E%3C/svg%3E"
  }), errorMessage), /*#__PURE__*/_react["default"].createElement("a", {
    className: theme.bodyCopy + " " + theme.marginBottom20 + " " + theme.marginTop10 + " " + _vinRecallLookup["default"].textLinkUnderline,
    href: "#" + whereCanFindId
  }, vinlookupurllabel), (rawData == null ? void 0 : (_rawData$getVinRecall5 = rawData.getVinRecallLookUpInformation) == null ? void 0 : _rawData$getVinRecall5.status) === '200' && renderVinProcessedData(), loading && (_CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(VinRecallSearch);
exports["default"] = _default;